import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../utils";
export const ChevronArrow = ({ size = 16, className, direction = "right", }) => {
    return (_jsx("svg", { className: cn("transition ease-in-out duration-300", className, {
            "rotate-90": direction === "left",
            "-rotate-90": direction === "right",
            "rotate-180": direction === "up",
        }), height: size, width: size, viewBox: "0 0 407.437 407.437", children: _jsx("polygon", { points: "386.258,91.567 203.718,273.512 21.179,91.567 0,112.815 203.718,315.87 407.437,112.815 " }) }));
};
